// extracted by mini-css-extract-plugin
export default {"share_container":"BundleShare_share_container__sEKKn","icon":"BundleShare_icon__-t9Ut","clipboard":"BundleShare_clipboard__KpYi+"};